import { Fragment } from 'react';
import Metrics from '/@/components/metrics';
import NewMetricsMobile from '/@/components/new-metrics-mobile';
import { _, _lazy } from '/@/locale';
import { isMobile } from '/@/utils';

const Features = ({ brand, productRecommendations, country }) => {
    return (
        <Fragment>
            {!isMobile() ? (
                <Metrics
                    title={_('Características')}
                    dataKey='features'
                    products={productRecommendations.map((recommendation) => recommendation.profile)}
                    brand={brand}
                />
            ) : (
                <NewMetricsMobile
                    title={_('Características')}
                    country={country}
                    dataKey='features'
                    products={productRecommendations.map((recommendation) => recommendation.profile)}
                    brand={brand}
                />
            )}
        </Fragment>
    );
};

Features.label = _lazy('Características');
Features.icon = 'caracteristics';

export default Features;
